var pagination = {
	backwardText: "上一页",
	forwardText: "下一页",
	pageRangeText: "第 {current} 页，共 {total} 页",
	itemsPerPageText: " 每页的项目数",
	itemRangeText: "{start}-{end}（共 {total} 项)",
	pageNumberText: "当前页"
};
var searchPlaceholder = "搜索...";
var zhTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { zhTranslations as default, pagination, searchPlaceholder };
